import { combineReducers } from 'redux'
import { GET_PROVINCE_ERROR, GET_PROVINCE_LOADING, GET_PROVINCE_SUCCESS, GET_CITY_ERROR, GET_CITY_LOADING, GET_CITY_SUCCESS } from './constant'

const getProvinceError = (state = false, action) => {
    switch (action.type) {
      case GET_PROVINCE_ERROR:
        return action.getProvinceError
      default:
        return state
    }
  }
  
  const getProvinceLoading = (state = false, action) => {
    switch (action.type) {
      case GET_PROVINCE_LOADING:
        return action.getProvinceLoading
      default:
        return state
    }
  }
  
  const getProvinceSuccess = (state = false, action) => {
    switch (action.type) {
      case GET_PROVINCE_SUCCESS:
        return action.getProvinceSuccess
      default:
        return state
    }
  }

  const provinces = (state = [], action) => {
    switch (action.type) {
      case GET_PROVINCE_SUCCESS:
        return action.provinces
      default:
        return state
    }
  }

  const getCityError = (state = false, action) => {
    switch (action.type) {
      case GET_CITY_ERROR:
        return action.getCityError
      default:
        return state
    }
  }
  
  const getCityLoading = (state = false, action) => {
    switch (action.type) {
      case GET_CITY_LOADING:
        return action.getCityLoading
      default:
        return state
    }
  }
  
  const getCitySuccess = (state = false, action) => {
    switch (action.type) {
      case GET_CITY_SUCCESS:
        return action.getCitySuccess
      default:
        return state
    }
  }

  const cities = (state = [], action) => {
    switch (action.type) {
      case GET_CITY_SUCCESS:
        return action.cities
      default:
        return state
    }
  }

  const wilayahReducer = combineReducers({
    getProvinceError,
    getProvinceLoading,
    getProvinceSuccess,
    provinces,

    getCityError,
    getCityLoading,
    getCitySuccess,
    cities
  })
  
  export default wilayahReducer
  